import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  AppBar,
  Toolbar,
  styled,
} from "@mui/material";
import { Link } from "react-router-dom";
import TypingEffect from "react-typing-effect";
import { Transition } from "react-transition-group";

const data = [
  { text: "plan a trip", subtext: "to see the northern lights in Norway" },
  {
    text: "Write a text",
    subtext: "asking a friend to be my plus-one at a wedding",
  },
  { text: "Write a thank-you note", subtext: "to my interviewer" },
  {
    text: "Suggest Fun activities",
    subtext: "for a team-building day with remote employees",
  },
  { text: "Brainstorm names", subtext: "for my fantasy football team" },
];

const FadeBox = styled(Box)<{ state: string }>(({ state }) => ({
  transition: "opacity 1000ms ease-in-out",
  opacity: state === "entered" ? 1 : 0,
}));

const Home: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [inProp, setInProp] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setInProp(false);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
        setInProp(true);
      }, 1000);
    }, 7000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box display="flex" height="100vh">
      {/* Left Section */}
      <Box
        flex={1}
        bgcolor="#FFF8DC"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        position="relative"
      >
        <AppBar position="absolute" color="transparent" elevation={0}>
          <Toolbar>
            <Typography variant="h6" color="secondary">
              ChatGPT
            </Typography>
          </Toolbar>
        </AppBar>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          height="100%"
          sx={{ ml: 2 }}
        >
          <Transition in={inProp} timeout={1000}>
            {(state) => (
              <FadeBox state={state}>
                <Typography variant="h4" color="secondary" fontWeight="bold">
                  {data[currentIndex].text}
                </Typography>
                <Typography variant="h5" color="secondary">
                  <TypingEffect
                    text={data[currentIndex].subtext}
                    speed={100}
                    eraseSpeed={0}
                    typingDelay={1000}
                    displayTextRenderer={(text) => (
                      <Box component="span">
                        {text.split("").map((char, i) => (
                          <Box
                            component="span"
                            key={i}
                            sx={char === " " ? { pr: "5px" } : {}}
                          >
                            {char}
                          </Box>
                        ))}
                      </Box>
                    )}
                  />
                </Typography>
              </FadeBox>
            )}
          </Transition>
        </Box>
      </Box>

      {/* Right Section */}
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="h3" gutterBottom>
          Get started
        </Typography>
        <Box display="flex" gap={2}>
          {["login", "signup"].map((action) => (
            <Button
              key={action}
              variant="contained"
              color="primary"
              component={Link}
              to={`/${action}`}
              sx={{ textTransform: "none", width: "150px" }}
            >
              {action === "login" ? "Log in" : "Sign up"}
            </Button>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Home;
